// extracted by mini-css-extract-plugin
export default {"modal_body":"ForgotPasswordModal_modal_body__O3jcd","modal_title":"ForgotPasswordModal_modal_title__sy8b7","btn_close":"ForgotPasswordModal_btn_close__ZwEYc"};